/* eslint-disable no-dupe-keys */
export default {
  equipment_dispatch: {
    name: '设备出库记录',
    // 属性（一般与对象内容匹配）
    prop: {
      serial_number: '批次号',
      city: '城市',
      district: '地区',
      address: '地址',
      equipment_productions: '设备',
      equipment_productions_count: '设备数量',
      internal_remark: '内部说明',
      information_clerk: '登记员',
      created_at: '出库时间',
      updated_at: '更新时间',
      charge_station_name: '充电站名称',
      parent_service_provider_id: '上级运营商',
      contact: '联系人',
      phone: '联系电话',
      city: '城市',
      district: '地区',
      address: '地址',
      longitude: '经度',
      latitude: '纬度',
      active_station: '激活建站'
    },
    // Enum的属性
    // 占位提示
    placeholder: {
      search_keyword: '批次号/桩编号',
      city: '请选择城市'
    },
    breadcrumb: {
      created_station: '一键建站'
    },
    tips: {
      contact_join_group: '联系人会自动加入到该充电站的家庭集团'
    },
    group_titles: {
      base_info: '基本信息',
      equipment_production_info: '设备信息列表',
      equipemnt_info: '设备信息'
    },
    btn: {
      created_active_station: '一键激活建站入口',
      private_charger_active: '私人桩激活'
    },
    export_file_name: '私人桩激活二维码.png'
  }
}
